// extracted by mini-css-extract-plugin
module.exports = {"cookies":"CookiesBar_cookies__feYzB","text":"CookiesBar_text__10Fbg","button":"CookiesBar_button__fPmhX"};